<template>
  <div class="control_bar top">
    <div class="search">
      <input
        type="text"
        class="search_field"
        placeholder="発生日時、レベル、補足情報から検索"
        v-model="inputValue"
      />
      <input
        type="button"
        :value="search"
        class="search_button"
        @click="auditLoggingFindAction"
      />
    </div>
    <controller
      :dispItems="dispItems"
      :allItems="auditLoggings"
      :router="router"
      @remove="remove"
      @exportFile="exportFile"
    >
    </controller>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow> </loadingModalWindow>
    </div>
    <div class="false_modal_window" v-if="showFalseModal">
      <finishModalWindow :question="falseWord" @close="closeModal">
      </finishModalWindow>
    </div>
    <div class="complete_modal_window" v-if="showFinishModal">
      <finishModalWindow :question="finishWord" @close="closeModal">
      </finishModalWindow>
    </div>
    <div class="false_modal_window" v-if="showFalseModal">
      <finishModalWindow :question="falseWord" @close="closeModal">
      </finishModalWindow>
    </div>
  </div>
</template>

<script>
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import finishModalWindow from '../modalWindow/finishModalWindow.vue'

import controller from '../controller.vue'
export default {
  props: ['dispItems'],
  data() {
    return {
      inputValue: '',
      search: '検索',
      router: '/auditLoggings',
      finishWord: '',
      falseWord: '',
      showFalseModal: false,
      showFinishModal: false,
      showloadingModal: false,
      confirmed: ''
    }
  },
  computed: {
    auditLoggings() {
      return this.$store.state.auditLoggings.auditLoggings
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    selectedLogList() {
      return this.$store.state.auditLoggings.selectedLogList
    }
  },
  components: {
    controller,
    loadingModalWindow,
    finishModalWindow
  },
  async mounted() {
    var uploader = document.getElementById('uploader')
    uploader.setAttribute('disabled', 'disabled')
  },
  methods: {
    remove(e) {
      // console.log(e)
    },
    closeModal(e) {
      this.showFinishModal = false
      this.showFalseModal = false
    },
    auditLoggingFindAction(event) {
      this.$store.dispatch('auditLoggings/searchvalue', this.inputValue)
      this.$emit('input-event', 0, this.inputValue)
      this.confirmed = this.inputValue
    },
    async exportFile() {
      this.showloadingModal = true
      this.$store.dispatch('auditLoggings/changeFindAuditLoggings', [])
      let endDateTime = this.$store.state.auditLoggings.searchEndDateTime
      let startDateTime = this.$store.state.auditLoggings.searchStartDateTime
      // 空チェック
      if (startDateTime === '') {
        let eventNumber = this.$store.state.error.errorCode.errorCode_320001
        let eventType = 9
        let reason = 'MSGCRC0202'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.falseWord =
          this.errorMsg.MSGCRC0202.name +
          this.errorMsg.MSGCRC0202.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFalseModal = true
        this.showloadingModal = false
        return
      }
      if (endDateTime === '') {
        let eventNumber = this.$store.state.error.errorCode.errorCode_320001
        let eventType = 9
        let reason = 'MSGCRC0203'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.falseWord =
          this.errorMsg.MSGCRC0203.name +
          this.errorMsg.MSGCRC0203.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFalseModal = true
        this.showloadingModal = false
        return
      }
      startDateTime = startDateTime.getTime()
      endDateTime = endDateTime.getTime()
      if (startDateTime > endDateTime) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_320001
        let eventType = 9
        let reason = 'MSGCRC0200'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.falseWord =
          this.errorMsg.MSGCRC0200.name +
          this.errorMsg.MSGCRC0200.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFalseModal = true
        this.showloadingModal = false
        return
      }

      try {
        let exportList = []
        if (this.selectedLogList.length !== 0) {
          exportList = this.selectedLogList
          exportList.sort((a, b) =>
            b.eventTime !== a.eventTime
              ? b.eventTime - a.eventTime
              : b.id - a.id
          )
        } else {
          await this.$store.dispatch('auditLoggings/setExportData', {
            startDateTime: startDateTime,
            endDateTime: endDateTime,
            searchWord: this.confirmed ? this.confirmed : ''
          })
          exportList = this.$store.state.auditLoggings.exportData
        }
        let result = this.$store.state.error.exportTitle.auditLogTitle
        for (let i = 0; i < exportList.length; i++) {
          for (let k of Object.keys(exportList[i])) {
            if (!exportList[i][k]) {
              exportList[i][k] = ''
            }
          }
          let detail = exportList[i].detail.replace(/[\r\n]/g, match => {
            if (match === '\r') {
              return '\\r'
            } else {
              return '\\n'
            }
          })
          result +=
            exportList[i].dataTime +
            ',' +
            exportList[i].dataSource +
            ',' +
            exportList[i].level +
            ',' +
            exportList[i].objectSource +
            ',' +
            exportList[i].eventId +
            ',' +
            this.exportSetDoubleQuotation(detail) +
            '\r\n'
        }
        if (result === '') {
          let eventNumber = this.$store.state.error.errorCode.errorCode_320004
          let eventType = 9
          let reason = 'MSGCRC0006'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.falseWord =
            this.errorMsg.MSGCRC0006.name +
            this.errorMsg.MSGCRC0006.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFalseModal = true
          this.showloadingModal = false
          return
        }
        let csv = ''
        csv += result
        let link = document.createElement('a')
        let bom = new Uint8Array([0xef, 0xbb, 0xbf])
        let blob
        if (window.navigator.msSaveOrOpenBlob) {
          // for ie
          blob = new Blob([bom, csv], {type: 'text/csv'})
          window.navigator.msSaveOrOpenBlob(blob, 'ログ一覧.csv')
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else if (window.webkitURL && window.webkitURL.createObjectURL) {
          // for chrome (and safari)
          blob = new Blob([bom, csv], {type: 'text/csv'})
          link.setAttribute('download', 'ログ一覧.csv')
          link.setAttribute('href', window.webkitURL.createObjectURL(blob))
          link.click()
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else if (window.URL && window.URL.createObjectURL) {
          // for firefox
          blob = new Blob([bom, csv], {type: 'text/csv'})
          link.setAttribute('download', 'ログ一覧.csv')
          link.setAttribute('href', window.URL.createObjectURL(blob))
          link.click()
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else {
          let eventNumber = this.$store.state.error.errorCode.errorCode_320002
          let eventType = 9
          let reason = 'MSGCRC0007'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.falseWord =
            this.errorMsg.MSGCRC0007.name +
            this.errorMsg.MSGCRC0007.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFalseModal = true
          this.showloadingModal = false
          return
        }
        window.URL.revokeObjectURL(link)
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_320003
        let eventType = 3
        let reason = ''
        if (error.response) {
          reason = 'MSGCRC0076 '
          this.falseWord =
            this.errorMsg.MSGCRC0076.name +
            this.errorMsg.MSGCRC0076.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
        this.showloadingModal = false
        return
      }
      this.showloadingModal = false
    },
    exportSetDoubleQuotation(value) {
      let c = ''
      let s = ''
      let doubleQuoteFlg = false
      // ダブルクォーテーションのエスケープ処理
      for (let i = 0; i < value.length; i++) {
        c = value.charAt(i)
        if (c === '"') {
          doubleQuoteFlg = true
          s = s + '"' + c
        } else {
          s = s + c
        }
      }
      if (doubleQuoteFlg) {
        s = '"' + s + '"'
      }
      // カンマがある場合、ダブルクォーテーションで囲む
      if (s.indexOf(',') >= 0 && !doubleQuoteFlg) {
        return '"' + s + '"'
      }
      return s
    }
  }
}
</script>

<style scoped>
.controller >>> span:hover {
  cursor: auto;
  text-decoration: none;
  opacity: 1;
}
.controller >>> .column_delete:hover,
.controller >>> .column_export:hover {
  cursor: default;
  text-decoration: none;
  opacity: 0.5;
}
.controller >>> .column_delete,
.controller >>> .column_add,
.controller >>> .txt,
.controller >>> .uploader,
.controller >>> .column_import,
.controller >>> .add_router {
  color: #bbb;
  pointer-events: none;
}
.search {
  margin: auto 0;
  height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/components/auditLoggings/controllbar.vue